import { gql } from '@apollo/client';

export const CREATE_NAVIGATION_LINK_MUTATOR = gql`
  mutation CreateNavigationLinkMutator(
    $group_id: String!
    $company_id: String!
    $navigation_link_data: JSON!
    $user_email: String!
  ) {
    createNavigationLink(
      group_id: $group_id
      company_id: $company_id
      navigation_link_data: $navigation_link_data
      user_email: $user_email
    )
  }
`;

export const UPDATE_NAVIGATION_LINK_MUTATOR = gql`
  mutation UpdateNavigationLinkMutator(
    $group_id: String!
    $company_id: String!
    $navigation_link_id: String!
    $updated_navigation_link: JSON!
    $original_navigation_link: JSON!
    $user_email: String!
  ) {
    updateNavigationLink(
      group_id: $group_id
      company_id: $company_id
      navigation_link_id: $navigation_link_id
      updated_navigation_link: $updated_navigation_link
      original_navigation_link: $original_navigation_link
      user_email: $user_email
    )
  }
`;

export const DELETE_NAVIGATION_LINK_MUTATOR = gql`
  mutation DeleteNavigationLinkMutator(
    $group_id: String!
    $company_id: String!
    $navigation_link_id: String!
    $user_email: String!
  ) {
    deleteNavigationLink(
      group_id: $group_id
      company_id: $company_id
      navigation_link_id: $navigation_link_id
      user_email: $user_email
    )
  }
`;
